import './App.css'
import { useState, useEffect } from 'react'
import Header from './components/header/Header'
import Home from './components/home/Home'
import About from './components/about/About'
import Skills from './components/skills/Skills'
// import Services from './components/services/Services'
import Qualification from './components/qualification/Qualification'
import Testimonials from './components/testimonials/Testimonials'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'
import ScrollUp from './components/scrollup/ScrollUp'
import Portfolio from './components/projects/Portfolio'

const App = () => {
  const [currentPath, setCurrentPath] = useState(window.location.pathname)
  const [isDarkMode, setDarkMode] = useState(true)

  const scrollToSection = (path, id, event) => {
    event.preventDefault()
    const section = document.getElementById(id)
    if (section) {
      if (id === 'home') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      } else {
        section.scrollIntoView({ behavior: 'smooth' })
      }
      window.history.pushState(null, '', path)
      setCurrentPath(path)
    }
  }

  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname)
    }

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [])

  // Handle dark mode toggle
  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.setAttribute('data-theme', 'dark')
    } else {
      document.documentElement.removeAttribute('data-theme')
    }
  }, [isDarkMode])

  return (
    <>
      <Header
        currentPath={currentPath}
        scrollToSection={scrollToSection}
        isDarkMode={isDarkMode}
        setDarkMode={setDarkMode}
      />
      <main className="main">
        <Home scrollToSection={scrollToSection} />
        <About />
        <Skills />
        {/* <Services /> */}
        <Qualification />
        <Portfolio />
        <Testimonials />
        <Contact />
      </main>
      <Footer currentPath={currentPath} scrollToSection={scrollToSection} />
      <ScrollUp scrollToSection={scrollToSection} />
    </>
  )
}

export default App
